<template>
  <div class="box">
    <div class="statistics px-2">
      <div class="person-info pt-3 pb-2">
        <div class="">
          <div
            class="img-box"
            :style="{
              backgroundImage: 'url(' + target.avatar + ')',
            }"
          >
            <img :src="target.avatar" alt="" />
          </div>
          <p>{{ target.name }}</p>
        </div>
        <p class="month" @click="showMonth = !showMonth">
          {{ fromatMonth }} <span :class="{ up: showMonth }"></span>
        </p>
      </div>
      <div class="statistics-content py-5">
        <div class="back-btn" @click="goback">查看考勤月历</div>
        <div class="list mt-5 px-4" v-if="report">
          <div class="item" v-if="report.SDWT">
            <span>应用出勤时数</span>
            <span>{{ report.SDWT }}</span>
          </div>
          <div class="item" v-if="report.FTWT">
            <span>有效出勤时数</span>
            <span>{{ report.FTWT }}</span>
          </div>

          <div class="item" v-if="report.C001">
            <span>计件出勤时数</span>
            <span>{{ report.C001 }}</span>
          </div>
          <div class="item" v-if="report.ABST">
            <span class="alert">旷工工时</span>
            <span class="alert">{{ report.ABST }}</span>
          </div>
          <div class="item" v-if="report.LTRM">
            <span class="alert">迟到分钟</span>
            <span class="alert">{{ report.LTRM }}</span>
          </div>
          <div class="item" v-if="report.ERLM">
            <span class="alert">早退分钟</span>
            <span class="alert">{{ report.ERLM }}</span>
          </div>
          <div class="item" v-if="report.O001">
            <span>平时加班(计薪) </span>
            <span>{{ report.O001 }}</span>
          </div>
          <div class="item" v-if="report.O002">
            <span>周末加班(计薪)</span>
            <span>{{ report.O002 }}</span>
          </div>
          <div class="item" v-if="report.O005">
            <span>节假日加班(计薪)</span>
            <span>{{ report.O005 }}</span>
          </div>
          <div class="item" v-if="report.O003">
            <span>平时加班(调休)</span>
            <span>{{ report.O003 }}</span>
          </div>
          <div class="item" v-if="report.O004">
            <span>周末加班(调休)</span>
            <span>{{ report.O004 }}</span>
          </div>
          <div class="item" v-if="report.O006">
            <span>节假日加班(调休)</span>
            <span>{{ report.O006 }}</span>
          </div>
          <div class="item" v-if="report.L003">
            <span>调休假</span>
            <span>{{ report.L003 }}</span>
          </div>
          <div class="item" v-if="report.L015">
            <span>出差</span>
            <span>{{ report.L015 }}</span>
          </div>
          <div class="item" v-if="report.L002">
            <span>年假</span>
            <span>{{ report.L002 }}</span>
          </div>
          <div class="item" v-if="report.L005">
            <span>病休假</span>
            <span>{{ report.L005 }}</span>
          </div>
          <div class="item" v-if="report.L001">
            <span>事假</span>
            <span>{{ report.L001 }}</span>
          </div>
          <div class="item" v-if="report.L004">
            <span>病假</span>
            <span>{{ report.L004 }}</span>
          </div>
          <div class="item" v-if="report.L011">
            <span>丧假</span>
            <span>{{ report.L011 }}</span>
          </div>
          <div class="item" v-if="report.L006">
            <span>婚假</span>
            <span>{{ report.L006 }}</span>
          </div>
          <div class="item" v-if="report.L007">
            <span>产假</span>
            <span>{{ report.L007 }}</span>
          </div>
          <div class="item" v-if="report.L009">
            <span>陪产假</span>
            <span>{{ report.L009 }}</span>
          </div>
          <div class="item" v-if="report.L013">
            <span>哺乳假</span>
            <span>{{ report.L013 }}</span>
          </div>
          <div class="item" v-if="report.L014">
            <span>工间假</span>
            <span>{{ report.L014 }}</span>
          </div>
          <div class="item" v-if="report.L012">
            <span>探亲假</span>
            <span>{{ report.L012 }}</span>
          </div>
          <div class="item" v-if="report.C003">
            <span>夜班次数</span>
            <span>{{ report.C003 }}</span>
          </div>
          <div class="item" v-if="report.C005">
            <span>签卡</span>
            <span>{{ report.C005 }}</span>
          </div>
          <div class="item" v-if="report.C006">
            <span>当月考勤天数</span>
            <span>{{ report.C006 }}</span>
          </div>
          <div class="item" v-if="report.C007">
            <span>补充工时</span>
            <span>{{ report.C007 }}</span>
          </div>
          <div class="item" v-if="report.L008">
            <span>产检假</span>
            <span>{{ report.L008 }}</span>
          </div>
          <div class="item" v-if="report.ERLT">
            <span>早退次数</span>
            <span>{{ report.ERLT }}</span>
          </div>
          <div class="item" v-if="report.LTRT">
            <span> 迟到次数</span>
            <span>{{ report.LTRT }}</span>
          </div>
        </div>
        <div v-else class="">
          <van-empty image="error" description="描述文字" />
        </div>
        <div class="desc px-4 mt-5">
          <!-- 处理异常状态，若有异议请及时反馈至部门考勤对接人，否则默认 考勤状况确认 -->
          <span class="xin">*</span
          >请今天18:00前确认考勤状态，未确认则按默认考勤状况确认，若有异议请及时联系部门考勤对接人
        </div>
      </div>
      <div class="btn" v-if="!hiddenBtn">
        <el-button
          v-if="report.is_gray == 0"
          @click="confirmKq"
          v-loading="loading"
          >确认</el-button
        >
        <el-button v-if="report.is_gray == 1" disabled class="confirmed"
          >已确认</el-button
        >
        <el-button v-if="report.is_gray == 2" disabled class="expired"
          >已过期</el-button
        >
      </div>
      <van-popup v-model="showMonth" round position="bottom">
        <van-datetime-picker
          v-model="nowMonth"
          type="year-month"
          title="请选择月份"
          :formatter="formatter"
          :min-date="minDate"
          :max-date="maxDate"
          @confirm="comfirmDateTime"
          @cancel="showMonth = false"
        />
      </van-popup>
    </div>
  </div>
</template>

<script>
import utils from "../../utils/utils";
import api from "@/apis";
import apiLogin from "@/apis";
export default {
  name: "statistics",
  data() {
    return {
      hiddenBtn: this.$route.query.hiddenBtn,
      target: {},
      id: "",
      month: "",
      // month: this.$route.query.month,
      report: {},
      nowMonth: new Date(),
      fromatMonth: "",
      showMonth: false,
      minDate: new Date("1970/1/1"),
      maxDate: new Date(),
      loading: false,
    };
  },
  mounted() {
    let token = window.sessionStorage.hrToken;
    if (token) {
      this.initUrlParams();
      this.initMonth();
      this.getReport();
      this.getUserinfo();
    } else {
      this.$bus.$on("processToken", (res) => {
        console.log(res);
        Promise.resolve(this.getHrToken(res)).then(() => {
          this.initUrlParams();
          this.initMonth();

          this.getReport();
          this.getUserinfo();
        });
      });
    }
  },
  methods: {
    //获取hrToken&用户信息
    getHrToken(username) {
      return new Promise((resolve) => {
        // console.log("username:" + new Date(), username);
        if (username) {
          let thisname = username;

          if (thisname === "17625010228" || thisname === "17637403245") {
            thisname = "10005038";
          } else if (thisname === "15093054787") {
            thisname = "10005038";
          }

          apiLogin.getUserToken({ username: thisname }).then((data) => {
            // console.log(data);
            const info = data.data;

            localStorage.setItem("salaryPhone", info.mobileNo);
            localStorage.setItem("salaryInfo", JSON.stringify(info));

            window.sessionStorage.hrToken = info.auth_token;
            resolve();
          });
        } else {
          // console.log("未登录");
          resolve();
        }
      });
    },
    //获取上月时间
    initUrlParams() {
      const params = location.search.slice(1);
      const paramsList = params.split("&");
      paramsList.map((item) => {
        const list = item.split("=");
        // if (list[0] == 'id') {
        //   this.id = list[1]

        //   // 设置上月时间格式
        //   const y = new Date().getFullYear()
        //   const m = (Number(this.id) - 1) || new Date().getMonth()
        //   const d = new Date().getDate()
        //   const time = new Date(`${y}/${m}/${d}`)
        //   this.month = time

        //   // let str = this.nowMonth + "-01";
        //   // let month = new Date(str.replace(/-/g, "/"));
        //   // month.setMonth(new Date(str.replace(/-/g, "/")).getMonth() - 1); //上月
        //   // this.month = utils.formatDate(month.getTime() / 1000, "yyyy-MM")
        // }
        if (list[0] == "month") {
          this.month = list[1];
        }
      });
    },
    //初始化月份
    initMonth() {
      let c = this.month + "-01";
      this.month
        ? (this.fromatMonth = utils.formatDate(
            new Date(c.replace(/-/g, "/")).getTime() / 1000,
            "yyyy-MM"
          ))
        : (this.fromatMonth = utils.formatDate(
            new Date().getTime() / 1000,
            "yyyy-MM"
          ));
    },
    //确认考勤
    confirmKq() {
      this.loading = true;
      api
        .confirmKq({ month: this.month })
        .then((res) => {
          if (res.code === 1) {
            this.getReport();
            this.$message({
              // showClose: true,
              message: "考勤已确认",
              type: "success",
            });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    //选择时间
    comfirmDateTime(e) {
      this.id = "";

      this.fromatMonth = utils.formatDate(e.getTime() / 1000, "yyyy-MM");
      this.showMonth = false;
      this.getReport();
    },
    //格式化时间
    formatter(type, val) {
      if (type === "year") {
        return `${val}年`;
      }
      if (type === "month") {
        return `${val}月`;
      }
      if (type === "day") {
        return `${val}日`;
      }
      if (type === "hour") {
        return `${val}时`;
      }
      return val;
    },
    //获取用户信息
    getUserinfo() {
      api.getUserinfo().then((res) => {
        this.target = res.data;
      });
    },
    //跳转
    goback() {
      this.$router.push({
        path: "/attendence",
        query: {
          month: this.month,
        },
      });
    },
    getReport() {
      api
        .getReport({
          month: this.fromatMonth + "-01",
        })
        .then((res) => {
          this.report = res.data;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;
@media screen and (max-width: 600px) {
  .statistics {
    width: 100%;
  }
}
@media screen and (min-width: 600px) {
  .statistics {
    width: 276px * $zoom;
  }
}
.box {
  display: flex;
  justify-content: center;
}
.statistics {
  // @include container();
  overflow: hidden;
  min-height: 100vh;
  background: #f7f9fa;
  &::v-deep .van-popup--bottom {
    width: 750px;
    left: 50%;
    transform: translateX(-50%);
  }
  .person-info {
    @include flex-between();
    width: 100%;
    height: 140px;
    background: #fff;
    margin: 24px 0;
    padding: 30px;
    border-radius: 16px;
    & > div {
      @include flex-start();
      align-items: center;
      .img-box {
        width: 48px;
        height: 48px;
        border-radius: 50%;
        overflow: hidden;
        background-repeat: no-repeat;
        background-size: 100% auto;
        background-position: center center;
        & > img {
          width: 100%;
          height: 100%;
          opacity: 0;
        }
      }
      & > p {
        margin-left: 15px;
        font-size: 32px;
        font-family: SimHei;
        font-weight: 400;
        color: #1e1e1e;
        & > span {
          margin-left: 15px;
          display: inline-block;
          border: 1px solid #008854;
          border-radius: 6px;
          padding: 4px 10px;
          text-align: center;
          font-size: 20px;
          font-family: SimHei;
          color: #008854;
        }
      }
    }
    .month {
      width: 180px;
      height: 48px;
      background: #ffffff;
      border-radius: 8px;
      font-size: 26px;
      font-family: Source Han Sans SC;
      font-weight: 400;
      color: #4f4f4f;
      line-height: 48px;
      text-align: center;
      @include flex-center();
      & > span {
        display: inline-block;
        width: 30px;
        height: 30px;
        background: url("~@/assets/arrow-down.png") no-repeat;
        background-size: 100% 100%;
      }
      & > .up {
        transform: rotate(180deg);
      }
    }
  }
  .statistics-content {
    background: #ffffff;
    border-radius: 10px;
    .back-btn {
      margin: 0 auto;
      width: 302px;
      height: 80px;
      background: #ffffff;
      box-shadow: 0px 0px 24px 0px rgba(168, 168, 168, 0.35);
      border-radius: 40px;
      font-size: 30px;
      font-family: SimHei;
      font-weight: 500;
      color: #1e1e1e;
      text-align: center;
      line-height: 80px;
      cursor: pointer;
    }
    .list {
      .item {
        height: 90px;
        @include flex-between();
        align-items: center;
        border-bottom: 1px solid #dedede;
        & > span {
          font-size: 32px;
          line-height: 90px;
          font-family: SimHei;
          font-weight: 400;
          color: #1e1e1e;
        }
        & > span:nth-child(1) {
          padding-left: 18px;
          position: relative;
          &::before {
            content: "";
            display: inline-block;
            width: 8px;
            height: 8px;
            background: #008854;
            border-radius: 50%;
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
          }
        }

        & > .alert {
          color: #ec6330;
          &::before {
            background: #ec6330 !important;
          }
        }
      }
    }
    .desc {
      font-size: 28px;
      font-family: SimHei;
      font-weight: 400;
      color: #999999;
      line-height: 36px;
      .xin {
        color: #f42323;
      }
    }
  }
  .btn {
    margin-top: 150px;
    .el-button {
      width: 100%;
      height: 96px;
      background: #4ea27c;
      border: none;
      border-radius: 16px;
      font-size: 32px;
      font-family: PingFang-SC-Heavy, PingFang-SC;
      font-weight: 800;
      color: #ffffff;
    }
    .confirmed {
      opacity: 0.6;
    }
    .expired {
      background: #999;
      opacity: 0.6;
    }
  }
}
</style>
